function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Button, Typography } from 'onboarding-components';
import produce from 'immer';
import { SetupGuideContext, Step } from 'common/onboarding/immersive-onboarding/types';
import { track, TrackingEvent, TrackingProperty } from 'common/onboarding/immersive-onboarding/tracking';
import { SummaryTable } from 'common/onboarding/immersive-onboarding/components';
import { ApiClient } from 'common/onboarding/immersive-onboarding/api-client';
import { useTranslation } from 'common/i18n/hooks';
import styles from './welcome-v2.module.styl';
import { FooterActionBar } from './footer-action-bar';
export const WelcomeWithPlannedEvents: React.FC = () => {
  const {
    t
  } = useTranslation();
  const {
    setStep,
    setupGuideInfo,
    setSetupGuideInfo
  } = React.useContext(SetupGuideContext);
  return <div className={styles.welcomeContent} data-sentry-component="WelcomeWithPlannedEvents" data-sentry-source-file="welcome-with-plan.tsx">
      <div className={styles.connectDataWrapper}>
        <div className={styles.connectDataCtaBox}>
          <div className={styles.connectDataText}>
            <Typography className={styles.noMargin} variant='headingSm' weight='bold' data-sentry-element="Typography" data-sentry-source-file="welcome-with-plan.tsx">
              {t("onboarding.welcome.unlock-insights")}
            </Typography>
            <Typography className={styles.subTitle} variant='bodySm' data-sentry-element="Typography" data-sentry-source-file="welcome-with-plan.tsx">
              {t("onboarding.welcome.connect-guide")}
            </Typography>
          </div>
          <div>
            <Button size='medium' onClick={() => {
            // TODO (Sonya) - distill this to one function
            const updatedStepsCompleted = produce(setupGuideInfo.stepsCompleted, draft => {
              draft.add(Step.Welcome);
            });
            ApiClient.updateCompleted(setupGuideInfo.projectId, updatedStepsCompleted);
            setSetupGuideInfo(_objectSpread(_objectSpread({}, setupGuideInfo), {}, {
              stepsCompleted: updatedStepsCompleted
            }));
            setStep(Step.Implement);
            track(TrackingEvent.WelcomeConnectDataClick, {
              [TrackingProperty.CurrentStep]: Step.Welcome,
              [TrackingProperty.Phase2]: true,
              [TrackingProperty.WelcomeVariant]: "with-table"
            });
          }} data-sentry-element="Button" data-sentry-source-file="welcome-with-plan.tsx">
              {t("onboarding.welcome.connect-data")}
            </Button>
          </div>
        </div>
        <SummaryTable onEdit={() => {
        setStep(Step.Events);
        track(TrackingEvent.SummaryTableEditClick, {
          [TrackingProperty.Phase2]: true
        });
      }} data-sentry-element="SummaryTable" data-sentry-source-file="welcome-with-plan.tsx" />
      </div>
      <div className={styles.footerActionBarWrapper}>
        <FooterActionBar data-sentry-element="FooterActionBar" data-sentry-source-file="welcome-with-plan.tsx" />
      </div>
    </div>;
};